export const WaNumberStatusBadge = ({ isActive }) => {
    
    return (
        <span
            className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-semibold tracking-wide ${isActive
                    ? "bg-emerald-500/10 text-emerald-400 border border-emerald-500/20"
                    : "bg-slate-700/40 text-slate-400 border border-slate-700/50"
                }`}
        >
            <span
                className={`w-1.5 h-1.5 rounded-full ${isActive
                        ? "bg-emerald-400 shadow-sm shadow-emerald-400/50"
                        : "bg-slate-500"
                    }`}
            />
            {isActive ? "Terhubung" : "Terputus"}
        </span>
    );
};